import Checkbox, { INDETERMINATE } from 'lib/Checkbox';
import { Option } from 'utils/multiDimensionalListUtils';
import { SelectionIndicator } from './SelectionIndicator';

interface SingleDropdownOptionProps {
  option: Option;
  isSelectable?: boolean;
  checkboxIsSelected: boolean | typeof INDETERMINATE;
  itemSelectionStatus: string;
  onChange: (checked: boolean) => void;
}

export const SingleDropdownOption = ({
  option,
  isSelectable,
  checkboxIsSelected,
  itemSelectionStatus,
  onChange,
}: SingleDropdownOptionProps): React.ReactElement => {
  if (isSelectable) {
    return (
      <div className="w-max grow px-1">
        <Checkbox
          value={option.code ?? undefined}
          label={
            <p className="text-neutral-950-opacity-80 body-base ml-2 inline-block max-w-[82px] break-words align-top">
              {option.name}
            </p>
          }
          isSelected={checkboxIsSelected}
          name={`group-${option.code}`}
          onChange={onChange}
          chipText={option?.chipText}
        />
      </div>
    );
  }

  return (
    <div className="flex items-center px-1">
      <SelectionIndicator status={itemSelectionStatus} />
      <p className="text-neutral-950-opacity-80 body-base">{option.name}</p>
    </div>
  );
};
